import React, { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import { AuthProvider } from "./auth/AuthProvider";
import { initTheme } from "./lib/theme";
import "@fontsource/inter/400.css";
import "@fontsource/inter/500.css";
import "@fontsource/inter/600.css";
import "@fontsource/jetbrains-mono/400.css";
import "./styles/tailwind.css";
import "./styles/index.css";
import i18n from "./i18n";

const container = document.getElementById("root");
const root = createRoot(container);

// Apply theme ASAP to avoid a flash of wrong theme
initTheme();

// Capturam ?plan=, ?business_type= si ?lang= inainte ca React Router sa navigheze si sa piarda query params.
// sessionStorage persista pe toata durata sesiunii tab-ului.
const _qs = new URLSearchParams(window.location.search);
if (import.meta.env.VITE_DEMO_MODE === "true") {
  const _p = _qs.get("plan");
  if (_p) sessionStorage.setItem("demo_plan", _p);
  const _bt = _qs.get("business_type");
  if (_bt) sessionStorage.setItem("demo_business_type", _bt);
}
const _lang = _qs.get("lang");
const SUPPORTED_LANGS = ["ro", "en", "de", "fr", "es", "bg"];
if (_lang && SUPPORTED_LANGS.includes(_lang)) {
  i18n.changeLanguage(_lang);
}

async function enableMocking() {
  if (import.meta.env.VITE_DEMO_MODE !== "true") return;
  const { worker } = await import("./mocks/browser");
  return worker.start({ onUnhandledRequest: "bypass" });
}

enableMocking().then(() => {
  root.render(
    <StrictMode>
      <AuthProvider>
        <App />
      </AuthProvider>
    </StrictMode>
  );
});
